var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_273_2023)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(0.461426)",
    fill: "#F5F6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06559 3.5975C9.42059 2.13417 11.5023 2.13417 11.8573 3.5975C11.9105 3.81733 12.0149 4.02148 12.162 4.19333C12.3091 4.36518 12.4947 4.49988 12.7036 4.58645C12.9126 4.67303 13.1391 4.70904 13.3646 4.69156C13.5901 4.67407 13.8083 4.60359 14.0014 4.48583C15.2873 3.7025 16.7598 5.17417 15.9764 6.46083C15.8588 6.65388 15.7885 6.87195 15.771 7.09731C15.7536 7.32267 15.7896 7.54897 15.876 7.75782C15.9625 7.96666 16.097 8.15215 16.2687 8.29921C16.4404 8.44627 16.6443 8.55075 16.8639 8.60417C18.3273 8.95917 18.3273 11.0408 16.8639 11.3958C16.6441 11.4491 16.4399 11.5535 16.2681 11.7006C16.0962 11.8477 15.9615 12.0332 15.875 12.2422C15.7884 12.4512 15.7524 12.6776 15.7699 12.9032C15.7874 13.1287 15.8578 13.3469 15.9756 13.54C16.7589 14.8258 15.2873 16.2983 14.0006 15.515C13.8075 15.3974 13.5895 15.327 13.3641 15.3096C13.1388 15.2922 12.9125 15.3281 12.7036 15.4146C12.4948 15.5011 12.3093 15.6356 12.1622 15.8073C12.0152 15.9789 11.9107 16.1829 11.8573 16.4025C11.5023 17.8658 9.42059 17.8658 9.06559 16.4025C9.01233 16.1827 8.90791 15.9785 8.76083 15.8067C8.61376 15.6348 8.42818 15.5001 8.21922 15.4135C8.01025 15.327 7.78379 15.291 7.55827 15.3084C7.33275 15.3259 7.11455 15.3964 6.92143 15.5142C5.63559 16.2975 4.16309 14.8258 4.94643 13.5392C5.06401 13.3461 5.13438 13.1281 5.15183 12.9027C5.16927 12.6773 5.1333 12.451 5.04682 12.2422C4.96034 12.0333 4.82581 11.8479 4.65415 11.7008C4.4825 11.5537 4.27856 11.4492 4.05893 11.3958C2.59559 11.0408 2.59559 8.95917 4.05893 8.60417C4.27876 8.5509 4.48291 8.44648 4.65476 8.29941C4.82661 8.15233 4.9613 7.96676 5.04788 7.75779C5.13446 7.54882 5.17047 7.32236 5.15298 7.09685C5.1355 6.87133 5.06501 6.65313 4.94726 6.46C4.16393 5.17417 5.63559 3.70167 6.92226 4.485C7.75559 4.99167 8.83559 4.54333 9.06559 3.5975Z",
    stroke: "#201E2A",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96143 10C7.96143 10.663 8.22482 11.2989 8.69366 11.7678C9.1625 12.2366 9.79838 12.5 10.4614 12.5C11.1245 12.5 11.7604 12.2366 12.2292 11.7678C12.698 11.2989 12.9614 10.663 12.9614 10C12.9614 9.33696 12.698 8.70107 12.2292 8.23223C11.7604 7.76339 11.1245 7.5 10.4614 7.5C9.79838 7.5 9.1625 7.76339 8.69366 8.23223C8.22482 8.70107 7.96143 9.33696 7.96143 10Z",
    stroke: "#201E2A",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_273_2023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.461426)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGear);
export default __webpack_public_path__ + "static/media/icon_gear.c342651468c57bd466a9b19015ac5983.svg";
export { ForwardRef as ReactComponent };